const config = {
  apiUrl: process.env.REACT_APP_API,
  uploadsUrl: process.env.REACT_APP_UPLOADS_URL
}

export default config;